export default class Header {

  constructor(el) {
    this.el = el
    this.hamburger = el.querySelector('.hamburger')
    this.hamburgerText = el.querySelector('.hamburger-text')
    this.menu = el.querySelector('.header--menu:not(.header--menu--solutions)')
    this.menuSolutions = el.querySelector('.header--menu--solutions')
    this.nav = el.querySelector('.header--nav')
    this.hero = document.querySelector('.hero')

    if (!this.hamburger) return

    this.bindHamburger()
    this.bindScroll()
    this.bindProducts()
    this.bindBack()
    this.updateNavClasses()
  }

  isMenuOpen() {
    return this.menu?.classList.contains('is-full') || this.menuSolutions?.classList.contains('is-full')
  }

  updateNavClasses() {
    if (this.isMenuOpen()) {
      this.nav.classList.add('is-white')
      this.nav.classList.remove('is-scrolled')
      return
    }

    if (this.hero) {
      const heroBottom = this.hero.getBoundingClientRect().bottom
      const navHeight = this.nav.getBoundingClientRect().height
      const onHero = heroBottom > navHeight

      this.nav.classList.toggle('is-white', onHero)
      this.nav.classList.toggle('is-scrolled', window.scrollY > 30)
      return
    }

    this.nav.classList.remove('is-white')
    this.nav.classList.toggle('is-scrolled', window.scrollY > 30)
  }

  bindScroll() {
    window.addEventListener('scroll', () => this.updateNavClasses(), { passive: true })
  }

  openMenu(target) {
    const isSolutions = target === 'solutions'
    this.menu?.classList.add('is-full')
    this.menuSolutions?.classList.toggle('is-full', isSolutions)

    this.hamburger.classList.add('is-active')
    if (this.hamburgerText) this.hamburgerText.style.opacity = '0'

    const activeMenu = isSolutions ? this.menuSolutions : this.menu
    this.revealItems(activeMenu)

    window.lenis?.stop()
    this.updateNavClasses()
  }

  closeMenus() {
    this.hideItems(this.menu)
    this.hideItems(this.menuSolutions)

    this.menu?.classList.remove('is-full')
    this.menuSolutions?.classList.remove('is-full')

    this.hamburger.classList.remove('is-active')
    if (this.hamburgerText) this.hamburgerText.style.opacity = '1'

    window.lenis?.start()
    this.updateNavClasses()
  }

  revealItems(menu) {
    if (!menu) return
    const items = [...menu.querySelectorAll('.header--menu-list li')]
    items.forEach((li, i) => {
      li.style.transitionDelay = `${250 + i * 60}ms`
      li.classList.add('is-visible')
    })
  }

  hideItems(menu) {
    if (!menu) return
    const items = [...menu.querySelectorAll('.header--menu-list li')]
    items.forEach(li => {
      li.style.transitionDelay = '0ms'
      li.classList.remove('is-visible')
    })
  }


  bindHamburger() {
    this.hamburger.addEventListener('click', () => {
      if (this.isMenuOpen()) {
        this.closeMenus()
      } else {
        this.openMenu('main')
      }
    })
  }

  bindBack() {
    const back = this.menuSolutions?.querySelector('.header--back')
    if (!back) return

    back.addEventListener('click', () => this.openMenu('main'))
  }

  bindProducts() {
    const link = this.el.querySelector('li.products > a')
    if (!link) return

    link.addEventListener('click', (e) => {
      e.preventDefault()
      this.openMenu('solutions')
    })
  }

}
